export const INLINE_NOTIFICATION_VARIANTS = {
    DEFAULT: 'default',
    GRADIENT: 'gradient',
} as const;

export type InlineNotificationVariant =
    (typeof INLINE_NOTIFICATION_VARIANTS)[keyof typeof INLINE_NOTIFICATION_VARIANTS];
